import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { getToken } from "../../utilities/authHelper";
import { fetchDashboards } from "../../utilities/AdminUtilities";

function ProductDashboard({ selectedProduct, show, handleClose }) {
  const [dashboardId, setDashboardId] = useState("");
  const [allowedFilterList, setAllowedFilterList] = useState("");
  const [allowedCountryCodes, setAllowedCountryCodes] = useState("");
  const [allowedCompanyList, setAllowedCompanyList] = useState("");
  const [detailsObject, setDetailsObject] = useState("{}");
  const [dashboards, setDashboards] = useState([]);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    fetchDashboards(setDashboards);
  }, []);

  const handleLink = async () => {
    const apiUrl = process.env.REACT_APP_API_URL;
    try {
      const response = await fetch(`${apiUrl}/admin/link_dashboard_product`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          product_id: selectedProduct.id,
          dashboard_id: dashboardId,
          allowed_filter_list: allowedFilterList
            .split(",")
            .map((item) => item.trim()),
          allowed_country_codes: allowedCountryCodes
            .split(",")
            .map((item) => item.trim()),
          allowed_company_list: allowedCompanyList
            .split(",")
            .map((item) => item.trim()),
          details_object: JSON.parse(detailsObject),
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to link product with dashboard");
      }

      setShowSuccessModal(true);
    } catch (error) {
      console.error("Error linking product with dashboard:", error);
      setShowErrorModal(true);
    }
  };

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            Link "{selectedProduct?.product_name}" to Dashboard
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Dashboard Selection */}
            <Form.Group className="mb-3" controlId="dashboardSelect">
              <Form.Label>Select Dashboard</Form.Label>
              <Form.Select
                value={dashboardId}
                onChange={(e) => setDashboardId(e.target.value)}
              >
                <option value="">Select a Dashboard</option>
                {dashboards.map((dashboard) => (
                  <option key={dashboard.id} value={dashboard.id}>
                    {dashboard.dashboard_name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            {/* Allowed Filter List */}
            <Form.Group className="mb-3" controlId="filterList">
              <Form.Label>Allowed Filter List (comma-separated)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter filters"
                value={allowedFilterList}
                onChange={(e) => setAllowedFilterList(e.target.value)}
              />
            </Form.Group>

            {/* Allowed Country Codes */}
            <Form.Group className="mb-3" controlId="countryCodes">
              <Form.Label>Allowed Country Codes (comma-separated)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter country codes"
                value={allowedCountryCodes}
                onChange={(e) => setAllowedCountryCodes(e.target.value)}
              />
            </Form.Group>

            {/* Allowed Company List */}
            <Form.Group className="mb-3" controlId="companyList">
              <Form.Label>Allowed Company List (comma-separated)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter company names"
                value={allowedCompanyList}
                onChange={(e) => setAllowedCompanyList(e.target.value)}
              />{" "}
            </Form.Group>

            {/* Details Object */}
            <Form.Group className="mb-3" controlId="detailsObject">
              <Form.Label>Details Object (JSON format)</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter details in JSON format"
                value={detailsObject}
                onChange={(e) => setDetailsObject(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleLink}>
            Link Dashboard
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Product successfully linked to dashboard.</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowSuccessModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Error Modal */}
      <Modal
        show={showErrorModal}
        onHide={() => setShowErrorModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          An error occurred while linking the product to the dashboard.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ProductDashboard;
